var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$wait.is("fetching_comments")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _vm.resource && _vm.resource.length > 0
              ? _c(
                  "div",
                  { staticClass: "sector-post__comments" },
                  _vm._l(_vm.resource, function (comment) {
                    return _c(
                      "div",
                      { staticClass: "comment" },
                      [
                        _c("Avatar", {
                          staticClass: "comment__avatar",
                          attrs: { resource: comment.user, "show-name": false },
                        }),
                        _vm._v(" "),
                        _c(
                          "article",
                          { staticClass: "comment__content" },
                          [
                            _c("header", { staticClass: "comment__metadata" }, [
                              _c("span", { staticClass: "comment__author" }, [
                                comment.user.name
                                  ? _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(comment.user.name) +
                                          "\n                                "
                                      ),
                                      comment.user.member
                                        ? _c("span", {
                                            staticClass: "member",
                                            domProps: {
                                              textContent: _vm._s(
                                                comment.user.member
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              comment.date
                                ? _c("span", { staticClass: "comment__date" }, [
                                    comment.can && comment.can.delete
                                      ? _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.handleDeleteClicked(
                                                  comment.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Delete")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    comment.is_edited
                                      ? _c("span", [_vm._v("Edited ")])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(comment.date) +
                                        "\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            comment.message
                              ? _c("ReadMore", {
                                  attrs: {
                                    content: comment.message,
                                    "wrapper-class": { comment_message: true },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "no-results" }, [
                  _c("span", [
                    _vm._v(
                      "There are currently no comments — be the first to share your thoughts!"
                    ),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }